import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBalance } from "../../features/transaction/transactionSlice";

function CreditUsage() {
  const dispatch = useDispatch();
  const { balance } = useSelector((state) => state.transactions);

  useEffect(() => {
    dispatch(getBalance());
  }, [dispatch]);

  const percentage = balance?.totalCredits
    ? Math.round((balance.totalDebitsAndRefunds / balance.totalCredits) * 100)
    : 0;

  const barColor =
    percentage > 80
      ? "bg-danger"
      : percentage > 50
        ? "bg-warning"
        : "bg-success";

  return (
    <div className="card border-0 shadow-lg">
      <div className="card-body p-5">
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div className="d-flex align-items-center">
            <div>
              <h2 className="fw-bold mb-1">Credit Usage</h2>
              <p className="-50 mb-0 mt-2" style={{ fontSize: "0.98rem" }}></p>
            </div>
          </div>
        </div>
        <div className="mb-4" style={{ borderTop: "1px solid #2a2a3e" }}></div>

        <div
          className="card border border-translucent shadow-sm mt-2"
          style={{
            background: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(10px)",
            borderRadius: "14px",
            padding: "20px",
          }}
        >
          <div className="card-body p-4">
            <h5 className="fw-bold mb-1">
              {(balance?.totalDebitsAndRefunds || 0).toLocaleString()} of{" "}
              {(balance?.totalCredits || 0).toLocaleString()} used{" "}
            </h5>
            <div className="d-flex align-items-center gap-3 flex-nowrap">
              <div className="progress flex-grow-1 mt-3" style={{ height: 18 }}>
                <div
                  className={`progress-bar ${barColor} d-flex align-items-center ${
                    percentage < 10
                      ? "justify-content-start ps-2"
                      : "justify-content-center"
                  }`}
                  role="progressbar"
                  style={{ width: `${percentage}%`, transition: "width .3s" }}
                  aria-valuenow={percentage}
                  aria-valuemin={0}
                  aria-valuemax={100}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: percentage < 10 ? "#000" : "#fff",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {percentage}%
                  </span>
                </div>
              </div>
            </div>
            <p className="mb-0 mt-2" style={{ fontSize: "1rem" }}>
              Credits are the units used to perform actions within the platform.
              Each operation consumes a certain number of credits.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditUsage;
